import { render } from "./ChatWindow.vue?vue&type=template&id=19f07275&scoped=true"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"

import "./ChatWindow.vue?vue&type=style&index=0&id=19f07275&scoped=true&lang=css"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f07275"]])

export default __exports__